// extracted by css-extract-rspack-plugin
export default {"root":"root-nEQ2ha text-sm-light","value":"value-bQe_5u"};